import React, { useEffect, useState } from 'react';
import {
    Alert,
    Avatar,
    Box,
    Button,
    Card,
    CardContent,
    Checkbox,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    ListItemAvatar,
    TextField,
    Typography,
    MenuItem,
    FormControlLabel,
    Grid
} from '@mui/material';
import axios from 'axios';
import { token, apiUrl } from '../../../../../api';
import api from '../../../../services/api';

const API_BASE = process.env.REACT_APP_BACKEND_SERVER || 'http://127.0.0.1:8000';

const ChannelDrawer = ({ channel, app_id, onClose }) => {
    console.log('Canal recebido no ChannelDrawer:', JSON.stringify(channel));
    const [openDialog, setOpenDialog] = React.useState(false);

    const [status, setStatus] = useState({ type: '', message: '' });
    const [listaSwitchboardsIntegrations, setListaSwitchboardsIntegrations] = useState([]);
    const [initialData, setInitialData] = useState(null);
    const [dadosIntegracao, setDadosIntegracao] = useState(null);
    const [hasChanges, setHasChanges] = useState(false);
    const [listaChatbots, setListaChatbots] = useState([]);

    // const [dadosIntegracao, setDadosIntegracao] = useState({
    //     status: '',
    //     type: '',
    //     displayName: '',
    //     defaultResponderEnabled_id: '', //null
    //     displayStyle: '', // button
    //     actionColor: '', // 0099ff
    //     conversationColor: '', //242424
    //     brandColor: '', // 65758e
    //     canUserCreateMoreConversations: '', // true
    //     accountId: null,
    //     businessManagerId: null,
    //     accountAppId: null,
    //     phoneNumber: null,
    //     phoneNumberId: null
    // });

    useEffect(() => {
        if (!channel) return;

        const normalized = {
            ...channel,
            defaultResponderEnabled_id: channel.defaultResponderEnabled_id?.id ?? '',
            chatbotResponder_id: channel.chatbotResponder_id?.id ?? ''
        };

        setInitialData(normalized);
        setDadosIntegracao(normalized);
        setHasChanges(false);
    }, [channel]);

    useEffect(() => {
        if (!initialData || !dadosIntegracao) return;

        const changed = JSON.stringify(initialData) !== JSON.stringify(dadosIntegracao);

        setHasChanges(changed);
    }, [dadosIntegracao, initialData]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setDadosIntegracao((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    // const handleChange = (e) => {
    //     console.log('handleChange chamado');
    //     const { name, value } = e.target;
    //     console.log(`name: ${name}, value: ${value}`);

    //     const newData = {
    //         ...dadosIntegracao,
    //         [name]: {
    //             ...dadosIntegracao[name],
    //             id: value
    //         }
    //     };
    //     console.log(`newData: ${JSON.stringify(newData)}`);

    //     setListaSwitchboardsIntegrations(newData);
    // };

    const deleteIntegration = () => {};

    const handleClickOpenDialog = () => {
        setOpenDialog(true);
    };
    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleAppChange = () => {};

    useEffect(() => {
        loadSwitchboardIntegrations();
    }, []);

    const handleSave = async () => {
        try {
            const res = await api.patch(`v1/apps/${app_id}/integrations/${channel.id}/`, dadosIntegracao);
            if (res.data) {
                console.log(`handleSave: ${JSON.stringify(res.data)}`);
                setStatus({ type: 'success', message: `Canal atualizado com sucesso!` });
            }
        } catch (err) {
            setStatus({ type: 'error', message: `Erro :${err}` });
        }
    };

    const loadSwitchboardIntegrations = async () => {
        console.log('entrou em loadSwitchboardIntegrations');
        if (!app_id) return;
        try {
            const response = await api.get(`v1/apps/${app_id}/switchboardIntegrations/`);

            console.log('Dados processados:', response.data);

            const swb_integrations = response.data.switchboardIntegrations || [];

            setListaSwitchboardsIntegrations(swb_integrations);
        } catch (err) {
            console.error('Erro ao carregar Switchboard Integrations', err);
            setStatus({ type: 'error', message: 'Erro ao carregar Switchboard Integrations' });
        }
    };

    const loadChatbots = async () => {
        if (!app_id) return;

        try {
            const res = await api.get(`v1/apps/${app_id}/chatbots/`);

            if (res.data) {
                setListaChatbots(res.data || []);
            } else {
                console.error('Erro ao carregar chatbots');
            }
        } catch (err) {
            console.error('Erro ao carregar chatbots', err);
        }
    };

    useEffect(() => {
        if (!app_id) return;
        loadChatbots();
    }, [app_id]);

    if (!dadosIntegracao) {
        return <Typography sx={{ m: 2 }}>Carregando dados do canal...</Typography>;
    }

    return (
        <>
            {status.message && (
                <Alert severity={status.type} sx={{ mb: 2 }}>
                    {status.message}
                </Alert>
            )}

            <Typography variant="h2" sx={{ mb: 2, mt: 3, ml: 2 }}>
                Dados do canal
            </Typography>

            {/* <ListItemAvatar marginLeft={30}> */}
            {dadosIntegracao.type === 'whatsapp' && (
                <Avatar marginLeft={40} sx={{ width: 80, height: 80, marginLeft: 40 }} src="/whatsapp_icon.png" />
            )}
            {dadosIntegracao.type === 'messenger' && <Avatar sx={{ width: 80, height: 80, marginLeft: 40 }} src="/messenger_icon.png" />}
            {dadosIntegracao.type === 'chat' && <Avatar sx={{ width: 80, height: 80, marginLeft: 40 }} src="/chat_icon3.png" />}
            {dadosIntegracao.type === 'instagram' && <Avatar sx={{ width: 80, height: 80, marginLeft: 40 }} src="/instagram_icon.png" />}
            {dadosIntegracao.type === 'email' && <Avatar sx={{ width: 80, height: 80, marginLeft: 40 }} src="/email_icon.png" />}
            {/* </ListItemAvatar> */}

            <Typography sx={{ marginLeft: 41, marginTop: 1 }}>{dadosIntegracao.displayName}</Typography>
            {/* <Typography>{dadosIntegracao.id}</Typography> */}

            {/* <Typography>{dadosIntegracao.status === 'active' ? 'Ativo' : 'Inativo'}</Typography> */}
            {/* </Box> */}
            {/* </CardContent> */}

            {/* NOME */}
            <Box sx={{ mt: 1 }}>
                <TextField
                    sx={{ ml: 20, mr: 1, mt: 4, xs: 1, sm: 1, width: '380px' }}
                    marginTop="10px"
                    right="10px"
                    name="displayName"
                    label="Nome"
                    value={dadosIntegracao.displayName}
                    onChange={handleChange}
                />
            </Box>

            {/* Status */}
            <Grid
                variant="contained"
                color="primary"
                sx={{
                    mb: 2,
                    ml: 20,
                    width: '380px',
                    marginLeft: '10px',
                    marginTop: 2,
                    display: 'flex'
                }}
                item
                marginLeft={20}
            >
                <TextField select name="status" label="Status" value={dadosIntegracao.status} onChange={handleChange} fullWidth>
                    <MenuItem value="active"> Ativo</MenuItem>
                    <MenuItem value="inative"> Inativo</MenuItem>
                </TextField>
            </Grid>

            {/* Número de telefone */}
            {channel.type === 'whatsapp' && (
                <Box sx={{ mt: 1 }}>
                    <TextField
                        sx={{ ml: 20, mr: 1, mt: 0, xs: 1, sm: 1, width: '380px' }}
                        marginTop="10px"
                        right="10px"
                        name="phoneNumber"
                        label="Número de telefone"
                        value={dadosIntegracao.phoneNumber}
                        onChange={handleChange}
                    />
                </Box>
            )}

            {/* Credenciais do Instagram */}
            {channel.type === 'instagram' && (
                <>
                    <Box sx={{ mt: 1 }}>
                        <TextField
                            sx={{ ml: 20, mr: 1, mt: 0, xs: 1, sm: 1, width: '380px' }}
                            marginTop="10px"
                            right="10px"
                            name="client_instance_id"
                            label="Instagram Business Account ID"
                            value={dadosIntegracao.client_instance_id || ''}
                            onChange={handleChange}
                        />
                    </Box>
                    <Box sx={{ mt: 1 }}>
                        <TextField
                            sx={{ ml: 20, mr: 1, mt: 2, xs: 1, sm: 1, width: '380px' }}
                            marginTop="10px"
                            right="10px"
                            name="client_instance_secret"
                            label="Access Token"
                            value={dadosIntegracao.client_instance_secret || ''}
                            onChange={handleChange}
                        />
                    </Box>
                </>
            )}

            {/* WhatsApp API Oficial - WABA ID (necessário pra criar/gerenciar Message Templates) */}
            {channel.type === 'whatsapp' && dadosIntegracao.client_type === 'official' && (
                <Box sx={{ mt: 1 }}>
                    <TextField
                        sx={{ ml: 20, mr: 1, mt: 0, xs: 1, sm: 1, width: '380px' }}
                        marginTop="10px"
                        right="10px"
                        name="businessManagerId"
                        label="WABA ID (Business Manager ID)"
                        value={dadosIntegracao.businessManagerId || ''}
                        onChange={handleChange}
                        helperText="Necessário pra criar e gerenciar Message Templates da Meta"
                    />
                </Box>
            )}

            {/* Select Default responde */}
            <Grid
                variant="contained"
                color="primary"
                sx={{
                    mb: 2,
                    ml: 20,
                    width: '380px',
                    marginLeft: '10px',
                    marginTop: 2
                }}
                item
                xs={12}
                sm={6}
                marginLeft={20}
                marginTop={2}
            >
                <TextField
                    name="defaultResponderEnabled_id"
                    select
                    label="Responde esse canal"
                    value={dadosIntegracao.defaultResponderEnabled_id}
                    onChange={handleChange}
                    fullWidth
                >
                    <MenuItem value="">Selecione</MenuItem>

                    {listaSwitchboardsIntegrations.map((swb) => (
                        <MenuItem key={swb.id} value={swb.id}>
                            {swb.name}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>

            {/* Select Chatbot Responder */}
            <Grid
                variant="contained"
                color="primary"
                sx={{
                    mb: 2,
                    ml: 20,
                    width: '380px',
                    marginLeft: '10px',
                    marginTop: 2
                }}
                item
                xs={12}
                sm={6}
                marginLeft={20}
                marginTop={2}
            >
                <TextField
                    name="chatbotResponder_id"
                    select
                    label="Chatbot que responde:"
                    value={dadosIntegracao.chatbotResponder_id || ''}
                    onChange={handleChange}
                    fullWidth
                >
                    <MenuItem value="">Selecione</MenuItem>

                    {Array.isArray(listaChatbots) &&
                        listaChatbots.map((chatbot) => (
                            <MenuItem key={chatbot.id} value={chatbot.id}>
                                {chatbot.name}
                            </MenuItem>
                        ))}
                </TextField>
            </Grid>

            <Box>
                <Button sx={{ ml: 20, mr: 1, mt: 3, color: '#000000' }} variant="outlined" color="secondary" onClick={onClose}>
                    Voltar
                </Button>

                <Button variant="contained" sx={{ mt: 3, backgroundColor: '#26c937' }} disabled={!hasChanges} onClick={handleSave}>
                    Salvar alterações
                </Button>

                <Button
                    variant="outlined"
                    sx={{ ml: 2, mr: 1, mt: 3, color: '#000000', backgroundColor: '#cc3d21' }}
                    color="secondary"
                    onClick={handleClickOpenDialog}
                >
                    Apagar integração
                </Button>
                <Dialog
                    open={openDialog}
                    onClose={handleCloseDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle variant="h3" id="alert-dialog-title">
                        {'Tem certeza que deseja apagar essa integração?'}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">Esta ação não podera ser desfeita.</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button sx={{ mr: 1, mt: 3, color: '#000000', backgroundColor: '#e0dbda' }} onClick={handleCloseDialog}>
                            Não
                        </Button>
                        <Button sx={{ mr: 1, mt: 3, color: '#000000', backgroundColor: '#cc3d21' }} onClick={handleCloseDialog} autoFocus>
                            Sim
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </>
    );
};
export default ChannelDrawer;
